import * as React from 'react';
import { Box, Paper, List, ListItem } from '@mui/material';

const PatientListScaffold: React.FC = () => {
    return (
        <Paper style={{ minHeight: '100%', maxHeight: '100%', overflow: 'auto' }}>
            <List>
                {[...Array(10)].map((_, i) => (
                    <ListItem key={i}>
                        <Box
                            sx={{
                                width: '100%',
                                height: 68,
                                backgroundColor: 'grey.200',
                                borderRadius: 1,
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </Paper>
    );
};

export default PatientListScaffold;